
import { defineComponent } from "vue";
import TradeHeader from "@/components/TradeHeader.vue";
export default defineComponent({
    name: "Trade",
    components: {
        TradeHeader,
    },
});
